<template>
  <v-layout row justify-center>
    <v-dialog v-if="userData" persistent v-model="dialog" max-width="1400">
      <v-card>
        <v-card-title>
          <span class="headline mr-4 d-flex">
            <v-img
              class="d-inline-block mr-2"
              :src="discountIcon"
              width="24px"
              contain
            ></v-img>
            <span>Discounts for user: {{ userData.email }}</span>
          </span>
          <v-btn absolute left depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="set_discount" data-vv-scope="set_discount" lazy-validation>
            <v-layout mb-2>
              <v-flex xs12>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  class="white--text mt-0"
                  @click="selected = null; setDiscountDialog = true;"
                >
                  <v-icon class="pl-2">add_circle_outline</v-icon>
                  Add Discount
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="loading" row justify-center py-5 >
              <v-progress-circular
                :size="150"
                :width="7"
                color="blue"
                indeterminate
              ></v-progress-circular>
            </v-layout>
            <v-layout v-else row wrap pb-3>
              <v-flex sx12>
                <v-data-table
                  class="no-action-table default-custom-table discounts-custom-table"
                  :headers="headers"
                  :items="discounts"
                  item-key="id"
                  :pagination.sync="pagination"
                  :total-items="total"
                  :loading="loading"
                  hide-actions
                  v-show="!loading"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.id }}</td>
                    <td class="text-xs-center">{{ props.item.percentage }} %</td>
                    <td>
                      {{ $moment(props.item.from_date).format('YYYY-MM-DD') }}
                    </td>
                    <td>
                      {{ $moment(props.item.to_date).format('YYYY-MM-DD') }}
                    </td>
                    <td>
                      {{ props.item.product_display_name }}
                    </td>
                    <td class="text-xs-center">
                      {{ $store.state.discount.sourcesText[props.item.source] }}
                    </td>
                    <td class="text-xs-center">
                      <router-link v-if="props.item.source_coupon_name" class="user-project-link" :to="{ name: 'Coupons', query: { search: props.item.source_coupon_name }}"> <span>{{ props.item.source_coupon_name }}</span></router-link>
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.source_coupon_redeemed_at ? $moment(props.item.source_coupon_redeemed_at).format('YYYY-MM-DD HH:mm') : '' }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.one_off ? 'Yes' : 'No' }}
                    </td>
                    <td class="text-xs-center">
                      <v-chip v-if="props.item.status === $store.state.discount.statuses.ACTIVE" label small class="white--text px-2" color="success"> ACTIVE </v-chip>
                      <v-chip v-else label small class="white--text px-2" color="blue-grey lighten-3"> ARCHIVED </v-chip>
                    </td>
                    <td class="text-xs-center">
                      <v-chip
                        v-if="props.item.status !== $store.state.discount.statuses.ARCHIVED"
                        class="pointer white--text custom-action-chip"
                        color="red"
                        label
                        small
                        @click="callConfirm('deleteDiscount', 'The discount will be deleted', props.item.id)"
                        v-tooltip.top-center="{
                          content: 'Remove discount',
                          trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
                        }"
                      >
                        <v-icon style="font-size: 16px;">delete</v-icon>
                      </v-chip>
                      <v-chip
                        v-if="props.item.status !== $store.state.discount.statuses.ARCHIVED"
                        class="pointer white--text custom-action-chip"
                        color="info"
                        label
                        small
                        @click="selected = props.item; setDiscountDialog = true"
                        v-tooltip.top-center="{
                          content: 'Edit discount',
                          trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
                        }"
                      >
                        <v-icon style="font-size: 16px;">edit</v-icon>
                      </v-chip>
                    </td>
                  </template>
                  <template slot="no-data">
                    <tr>
                      <td class="text-xs-center" colspan="8">
                        <span>No discounts</span>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <ToolbarPagerComponent class="mt-1 pa-3" :pagination="pagination"></ToolbarPagerComponent>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SetDiscountModal v-if="setDiscountDialog" :setDiscountDialog="setDiscountDialog" :userData="userData" :discount="selected"></SetDiscountModal>
    <ConfirmModal v-if="confirmDialog" :confirmDialog="confirmDialog" :confirmText="confirmText" :loading="loading" :param="confirmParam"></ConfirmModal>
  </v-layout>
</template>

<script>
import ConfirmMixin from '@/mixins/ConfirmMixin'

export default {
  name: 'UserDiscountsModal',
  mixins: [ConfirmMixin],
  $_veeValidate: {
    validator: 'new'
  },
  props: ['userDiscountDialog', 'userData'],
  data () {
    return {
      dialog: this.userDiscountDialog,
      loading: false,
      discountIcon: require('@/assets/img/brightness_percent_grey.png'),
      setDiscountDialog: false,
      selected: null,
      discounts: [],
      pagination: { sortBy: 'id', descending: true, rowsPerPage: 25 },
      total: 0,
      page: 1,
      headers: [
        { text: '#', value: 'id', align: 'left' },
        { text: 'Discount', sortable: true, value: 'percentage', align: 'middle' },
        { text: 'From_date', sortable: true, value: 'from_date', align: 'left' },
        { text: 'To date', sortable: true, value: 'to_date', align: 'left' },
        { text: 'Product', sortable: false, value: 'product_display_name', align: 'middle' },
        { text: 'Source', sortable: true, value: 'source', align: 'middle' },
        { text: 'Promo Code', sortable: true, value: 'source_coupon_name', align: 'middle' },
        { text: 'Promo Code Redeemed at', sortable: true, value: 'source_coupon_redeemed_at', align: 'middle' },
        { text: 'One off', sortable: true, value: 'one_off', align: 'middle' },
        { text: 'Status', sortable: true, value: 'status', align: 'middle' },
        { text: 'Action', sortable: false, value: '', align: 'middle' }
      ]
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
    this.getUserDiscounts()
    this.$on('updateDiscountsList', (value) => {
      this.getUserDiscounts()
    })
    this.$on('setDiscountDialog', (value) => {
      this.setDiscountDialog = value
    })
    setTimeout(() => {
      this.addPaginationWatcher()
    }, 1500)
  },
  watch: {
    userDiscountDialog: {
      handler () {
        this.dialog = this.userDiscountDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('userDiscountDialog', this.dialog)
      }
    }
  },
  computed: {
    computedPagination: function () {
      return Object.assign({}, this.pagination)
    }
  },
  beforeDestroy () {
    this.$off('updateDiscountsList')
    this.$off('setDiscountDialog')
  },
  methods: {
    getUserDiscounts () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let params = {
        user_id: this.userData.id,
        page: page,
        count: rowsPerPage,
        order_by: sortBy,
        direction: (descending) ? 'desc' : 'asc',
        filter_blocks: []
      }
      this.$store.dispatch('GET_DISCOUNTS', params).then(res => {
        this.discounts = res.data
        this.total = res.total_count
        this.pagination.totalItems = res.total_count
        this.loading = false
      }, err => {
        console.log('GET_DISCOUNTS ERROR', err)
        this.loading = false
        this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${this.$services.getApiError(err)}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    deleteDiscount (id) {
      this.loading = true
      this.$store.dispatch('DELETE_DISCOUNT', id).then(res => {
        this.loading = false
        this.selected = null
        this.getUserDiscounts()
      }, err => {
        console.log('DELETE_DISCOUNT ERROR', err)
        this.loading = false
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    },
    addPaginationWatcher () {
      this.$watch('computedPagination', (newVal, oldVal) => {
        let middleVal = Object.assign({}, oldVal)
        middleVal.totalItems = newVal.totalItems
        // if not only totalItems changes
        if (this.total > 0 && JSON.stringify(middleVal) !== JSON.stringify(newVal)) {
          this.getUserDiscounts()
        }
      }, { deep: true })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>

<style>
.pointer .v-chip__content {
  cursor: pointer;
}
.discounts-custom-table {
  width: 100%;
}
.discounts-custom-table table.v-table thead th:first-child {
  /* min-width: 145px; */
}
.discounts-custom-table table.v-table thead th:last-child {
  min-width: 110px;
}
@media only screen and (max-width: 600px){
  .discounts-custom-table table.v-table tbody td {
    padding: 0 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserDiscountsModal.vue